const SitemapRoutes = {
  getSitemaps: 'admin/gpt/sitemap',
  addSitemap: 'admin/gpt/sitemap',
  uploadSitemap: 'admin/gpt/sitemap/upload?',
  deleteSitemap: 'admin/gpt/sitemap',
};

export default SitemapRoutes